import ThreeD from '../../inspirationImgs/3D.svg'
import Audio from '../../inspirationImgs/Audio.svg'
import Business from '../../inspirationImgs/Business.svg'
import Comic from '../../inspirationImgs/Comic.svg'
import Design from '../../inspirationImgs/Design.svg'
import Drawing from '../../inspirationImgs/Drawing.svg'
import Education from '../../inspirationImgs/Education.svg'
import Films from '../../inspirationImgs/Films.svg'
import Fitness from '../../inspirationImgs/Fitness.svg'
import Gaming from '../../inspirationImgs/Gaming.svg'
import Music from '../../inspirationImgs/Music.svg'
import Photography from '../../inspirationImgs/Photography.svg'
import Improvement from '../../inspirationImgs/Improvement.svg'
import SoftwareDev from '../../inspirationImgs/SoftwareDev.svg'
import Writing from '../../inspirationImgs/Writing.svg'


export const InspirationData = [
    {
        title: '3D',
        desc: 'Perfect your craft with the same tools used at Dreamworks and Pixar.',
        tags: ['blender','3D model', 'spark ar'],
        color: '#23a094',
        svg: `${ThreeD}`
    },
    {
        title: 'Audio',
        desc: 'Open your ears and mind to interviews, meditations and true crime thrillers.',
        tags: ['meditation','hypnosis', 'submiminal messages'],
        color: 'hsla(7.039106145251395, 75.53%, 53.53%, 1.00)',
        svg: `${Audio}`
    },
    {
        title: 'Business & Money',
        desc: 'Learn to earn in an increasingly unpredictable world.',
        tags: ['notion template','investing', 'instagram'],
        color: '#23a094',
        svg: `${Business}`
    },
    {
        title: 'Comics & Graphic Novels',
        desc: 'Sequential art woth loads of heart. Welcome to a paradise of panels.',
        tags: ['comic','manga','anime'],
        color: 'hsla(60.62499999999999, 88.89%, 57.65%, 1.00)',
        svg: `${Comic}`
    },
    {
        title: 'Design',
        desc: 'Code, design and ship your technical dream product with these technical resources.',
        tags: ['textures','mockup','font'],
        color: 'hsla(47.294117647058826, 100.00%, 50.00%, 1.00)',
        svg: `${Design}`
    },
    {
        title: 'Drawing & Painting',
        desc: 'Tutorials, plugins, and brushes from pro concept artists and illustrators.',
        tags: ['procreate','brushes','art'],
        color: '#90a8ed',
        svg: `${Drawing}`
    },
    {
        title: 'Education',
        desc: 'Pick up a new skill with courses and guides from world-class props',
        tags: ['eduction','certification exams', 'learning'],
        color: '#23a094',
        svg: `${Education}`
    },
    {
        title: 'Fiction Books',
        desc: 'Short stories, novellas and epic tomes full of interesting characters and worlds',
        tags: ['sci-fi','poetry','fiction'],
        color: '#90a8ed',
        svg: `${Education}`
    },
    {
        title: 'Films',
        desc: 'Have a movie night with some of the best stories to hit the small screen',
        tags: ['after effects','vj loops', 'luts'],
        color: 'hsla(7.039106145251395, 75.53%, 53.53%, 1.00)',
        svg: `${Films}`
    },
    {
        title: 'Fitness and Health',
        desc: `Wherher you're looking to shed or shred, here ar coaches to pump you up.`,
        tags: ['fitness','workout program','yoga'],
        color: 'hsla(47.294117647058826, 100.00%, 50.00%, 1.00)',
        svg: `${Fitness}`
    },
    {
        title: 'Gaming',
        desc: 'Explore new worlds from the worlds most creative indoe developers.',
        tags: ['vrchat','avatar','assets'],
        color: 'hsla(7.039106145251395, 75.53%, 53.53%, 1.00)',
        svg: `${Gaming}`
    },
    {
        title: 'Music & Sound Design',
        desc: 'Tracks, beats and loops from the best musicians and engineers in the biz',
        tags: ['ableton','sample pack','sheet music'],
        color: 'hsla(60.62499999999999, 88.89%, 57.65%, 1.00)',
        svg: `${Music}`
    },
    {
        title: 'Photography',
        desc: 'Get snapping with pro presets, stock imagery and digi darkroom needs',
        tags: ['reference photos', 'stock photos', 'photobashh'],
        color: '#23a094',
        svg: `${Photography}`
    },
    {
        title: 'Recorded Music',
        desc: 'Tracks and albums from the best musicians and artists in the biz',
        tags: ['singles', 'jazz', 'intrumental music'],
        color: 'hsla(60.62499999999999, 88.89%, 57.65%, 1.00)',
        svg: `${Music}`
    },
    {
        title: 'Self Improvement',
        desc: 'Move your body and your audience with guides, videos and more',
        tags: ['coloring pages','printable','productivity'],
        color: 'hsla(7.039106145251395, 75.53%, 53.53%, 1.00)',
        svg: `${Improvement}`
    },
    {
        title: 'Software Development',
        desc: 'Learn to code and tools to help you code more productively.',
        tags: ['prrogramming','windows','theme'],
        color: 'hsla(47.294117647058826, 100.00%, 50.00%, 1.00)',
        svg: `${SoftwareDev}`
    },
    {
        title: 'Writing and Publishing',
        desc: 'Fill your brain woth words and wisdom from creative authors and storytellers.',
        tags: ['kdp interior','ebook','low content books'],
        color: '#90a8ed',
        svg: `${Writing}`
    },
]